export default {
  state: () => ({}),
  mutations: {},
  actions: {},
};
